import type { IAllWinnerCategories } from '~/interfaces/winners/winnersInterfaces';
import type {
  IMyBigWinsRequest,
  IMyBigWinsResponse,
} from '~/interfaces/winners/my-big-wins';

export const useWinnerService = () => {
  const { $fetch } = useNuxtApp();

  const fetchAllWinners = async () => {
    try {
      return await $fetch<IAllWinnerCategories>(`api/v1/Widget/WinnerCircle`, {
        base: 'baseC',
        useRegionCode: true,
        useChannel: true,
        useEnvironment: true,
        useCache: true,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const fetchMyBigWins = async (
    options: IMyBigWinsRequest = { skip: 0, limit: 8 },
  ): Promise<IMyBigWinsResponse> => {
    try {
      return await $fetch<IMyBigWinsResponse>(`api/v1/Gaming/BigWins`, {
        base: 'base',
        useAuthentication: true,
        query: {
          ...(Object.keys(options).length && options),
        },
      });
    } catch (e) {
      console.error(e);
    }
  };

  return {
    fetchAllWinners,
    fetchMyBigWins,
  };
};
